import type { ReactNode } from 'react';
import React from 'react';
import type { DeepReadonly } from '@itandi/itandi-bb-ui';
import { Table, Tbody, Th, Thead, Tr } from '@itandi/itandi-bb-ui';
import { LineUserAccountListRow } from '~/components/common/line_user_accounts/LineUserAccountListRow';
import type {
  LineUserAccount,
  LineUserAccountEdit
} from '~/models/LineUserAccount';
import type { NskResponse } from '~/models/Api';

type Props = DeepReadonly<{
  lineUserAccounts: LineUserAccount[];
  handleMutate: () => Promise<void>;
  handleUpdate: (
    lineUserAccountEdit: LineUserAccountEdit,
    lineUserAccountId: number
  ) => Promise<NskResponse<void>>;
  handleDestroy: (lineUserAccountId: number) => Promise<NskResponse<void>>;
}>;

export const LineUserAccountList: React.FC<Props> = ({
  lineUserAccounts,
  handleMutate,
  handleUpdate,
  handleDestroy
}: Props) => {
  const renderRow = React.useCallback(
    (lineUserAccount: LineUserAccount): ReactNode => (
      <LineUserAccountListRow
        key={lineUserAccount.id}
        handleDestroy={handleDestroy}
        handleMutate={handleMutate}
        handleUpdate={handleUpdate}
        lineUserAccount={lineUserAccount}
      />
    ),
    [handleDestroy, handleMutate, handleUpdate]
  );
  return (
    <Table>
      <Thead>
        <Tr>
          <Th>名前</Th>
          <Th width="6rem">操作</Th>
        </Tr>
      </Thead>
      <Tbody>{lineUserAccounts.map(renderRow)}</Tbody>
    </Table>
  );
};
